<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'worklogs',
})
</script>
<template>
  <div>
    <a-calendar  v-if="ok" v-model:value="notime" valueFormat="YYYY-MM-DD" @panelChange="panelChange" @select="dateSelect" >
      <template #dateCellRender="{ current }">
        <ul >
          <li @click.stop="showDetail(item, i)" class="flex" v-for="(item, i) in getDateData(current)" :key="i">
              <a-badge :status="item.rendering"  :text="item.title" />
          </li>
        </ul>
      </template>
      <template #monthCellRender="{ current }">
        <div v-if="worklogs.length > 0" class="notes-month">
          <ul >
            <li @click.stop="showDetail(item, i)" class="flex" v-for="(item, i) in getMonthData(current)" :key="i">
              <a-badge :status="item.rendering"  :text="item.title" />
            </li>
          </ul>
        </div>
      </template>
    </a-calendar>
    <a-modal v-model:open="visible" @ok="submit" title="工作日志" :okText="add?'确定':'删除本条'">
      <div v-if="add == false && worklog" class="flex">
        <p class="flex1">
          <a-badge :status="worklog.rendering"  :text="worklog.title" />
        </p>
        <p class="opacity-50 " v-if="worklog.stime == worklog.etime">{{ worklog.stime }}</p>
        <p class="opacity-50" v-else>{{ worklog.stime }}至{{ worklog.etime }}</p>
      </div>
      <div v-else-if="worklog">
        <p>
          <a-textarea v-model:value="worklog.title" placeholder="请输入日志内容" :rows="4"></a-textarea>
        </p>
        <p>
          <a-range-picker  valueFormat="YYYY-MM-DD"  v-model:value="worklog.date" />
        </p>
        <p>
          <a-radio-group v-model:value="worklog.rendering"
            :options="[{ label: '处理中', value: 'default' }, { label: '完成', value: 'success' }, { label: '紧急', value: 'error' }]" />
        </p>
      </div>
    </a-modal>
  </div>
</template>
<script setup lang="ts" name="worklogs">
import { getDefaultAutoSelectFamily } from 'net';
import { reactive,ref,onMounted } from 'vue';
import api from '@/utils/http/service'
import {message} from 'ant-design-vue'
import { Dayjs } from 'dayjs';

  const notime=ref<Date|String>('')
  let worklogs=reactive<Array>([])
  const visible=ref<Boolean>(false)
  let worklog=ref<any>({})
  const add=ref<Boolean>(true)
  const ok=ref<Boolean>(false)
  onMounted(()=>{
    getData(new Date())
  })
    const date2string =(d:Date) =>{
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    }
    const getDateData =(d:Dayjs)=> {
        let target = new Date(d)
      let ar = worklogs.filter(e => {
        let st = new Date(e.stime)
        let et = new Date(e.etime)
        if (e.stime == e.etime) {
          return date2string(st) == date2string(target)
        } else {
          return target >= st && target <= et
        }
      })
      return ar
    }
    const getMonthData= (d:String)=> {
      let target = new Date(d)
      let ar = worklogs.filter(e => {
        let st = new Date(e.stime)
        let et = new Date(e.etime)
        return (st.getFullYear() == target.getFullYear() || et.getFullYear == target.getFullYear()) && (st.getMonth() == target.getMonth() || et.getMonth == target.getMonth())
      })
      return ar
    }
    const  dateSelect =(d:String)=> {
      worklog.value = { ID: 0, stime: d, etime: d, title: '', rendering: 'default', date: [d,d] }
      add.value = true
      visible.value = true
    }
    const panelChange= (e:String)=> {
      getData(e)
    }
    const getData =(time:String)=> {
      worklogs = []
      ok.value=false
      api.worklogs.list({ pageFlag: false, time: time }).then(res => {
        ok.value=true
        if (res.state == 1) {
          worklogs = res.data
        }
      })
    }
    const showDetail =(item:Object, i:Number)=> {
      worklog.value = item
      add.value = false
      visible.value = true
    }
    const del =():void=> {
      let index = worklogs.findIndex(e => { return e.ID == worklog.value.ID })
      if (index > -1) {
        api.worklogs.del(worklog.value.ID).then(res => {
          if (res.state == 1) {
            worklogs.splice(index, 1)
          }
          worklog.value = null
          visible.value = false
        })
      }
    }
    const submit= () :void=>{
      if(add.value == false){
        del()
      }else if (add.value == true) {
        if (worklog.value.title == '') {
          message.error('日志内容不可为空')
          return false
        }
        if(worklog.value.date.length==0){
            message.error('日志时间不可为空')
          return false
        }
        if(worklog.value.date.length==1){
            worklog.value.stime=worklog.value.date[0]
        }
        if(worklog.value.date.length==2){
            worklog.value.etime=worklog.value.date[1]
        }
        if (worklog.value.stime == '') {
          message.error('日志时间不可为空')
          return false
        }
        api.worklogs.add(worklog.value).then(res => {
          if (res.state == 1 && add.value == true) {
            worklogs.push(res.data)
          }
          worklog.value = null
          visible.value = false
        })
      }
 
    }
    const addDay =(date:String, dayNumber:Number)=> {

      let d = date ? new Date(date) : new Date();

      var ms = dayNumber * (1000 * 60 * 60 * 24)

      var newDate = new Date(d.getTime() + ms);

      return newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate()

    }
</script>
